var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_571_22090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.078125H30V30.0781H0V0.078125ZM27.5425 22.9231C27.3238 21.5544 26.4325 20.4044 23.7887 19.3319C22.8687 18.9006 21.8462 18.6006 21.5425 17.9069C21.4287 17.4944 21.4112 17.2694 21.485 17.0256C21.6725 16.2181 22.6287 15.9756 23.3787 16.2006C23.8662 16.3506 24.3163 16.7256 24.5988 17.3256C25.8913 16.4806 25.8913 16.4806 26.7925 15.9194C26.455 15.3944 26.2875 15.1681 26.06 14.9444C25.2725 14.0631 24.2237 13.6131 22.5175 13.6519L21.6362 13.7631C20.7913 13.9694 19.9862 14.4194 19.4988 15.0194C18.0737 16.6331 18.485 19.4456 20.21 20.6081C21.9162 21.8831 24.4113 22.1631 24.73 23.3644C25.03 24.8269 23.6425 25.2956 22.2725 25.1269C21.2588 24.9019 20.6975 24.3944 20.0788 23.4569L17.7913 24.7706C18.0537 25.3706 18.3538 25.6319 18.8038 26.1569C20.9788 28.3519 26.4163 28.2394 27.3925 24.9019C27.4287 24.7894 27.6925 24.0206 27.485 22.8394L27.5425 22.9231ZM16.3137 13.8669H13.5038C13.5038 16.2894 13.4925 18.6969 13.4925 21.1231C13.4925 22.6631 13.5712 24.0769 13.32 24.5119C12.9075 25.3731 11.845 25.2631 11.3625 25.1119C10.8675 24.8669 10.6163 24.5294 10.325 24.0431C10.2463 23.9119 10.1875 23.7981 10.1663 23.7981L7.885 25.2044C8.26625 25.9919 8.8225 26.6694 9.54 27.1006C10.6088 27.7381 12.045 27.9444 13.5487 27.6069C14.5275 27.3244 15.3712 26.7431 15.8125 25.8431C16.45 24.6806 16.315 23.2556 16.3088 21.6606C16.3237 19.0931 16.3088 16.5244 16.3088 13.9369L16.3137 13.8669Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_571_22090"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0 0.078125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJs);
export default __webpack_public_path__ + "static/media/js.ab7d5afd842aa107c3bb8853cab9be6c.svg";
export { ForwardRef as ReactComponent };